export const CacheSelectDeviceInfoKey = 'CacheSelectDeviceInfoKey'
export const CacheSelectJijiaOrderInfoKey = 'CacheSelectJijiaOrderInfoKey'
export const CacheSelectedContractAgree = 'CacheSelectedContractAgree'
export const CacheJijiaDeviceList = 'CacheJijiaDeviceList'
